// extracted by mini-css-extract-plugin
export var wordContainer = "_sm-0";